
const fornecedorGridConfig = {
  idField: "idFornecedor",
    columns: [
    { header: "Nome", field: "NOME_FANTASIA" },
    { header: "Categoria", field: "DESCRICAO" },
    { header: "Telefone", field: "TELEFONE" },
    { header: "E-mail", field: "EMAIL" }
  ]
};

export default fornecedorGridConfig;